// tslint:disable
export namespace LegalEntitiesApi {
  export enum LegalEntityTypeEnum {
    standardLender = 'standardLender',
    subLender = 'subLender',
    superLender = 'superLender',
    borrower = 'borrower',
  }
  export interface AuditDto {
    userId?: string;
    userName?: string;
    date?: string;
  }
  export interface LegalEntitiesGroupDto {
    legalEntitiesGroupId?: string;
    name?: string;
    company?: string;
    legalEntitiesIds?: Array<string>;
    descendantsIds?: Array<string>;
    description?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    rowVersion?: number;
    entityType?: 'borrower' | 'lender';
    groupType?: 'billing' | 'caNotification' | 'general' | 'hierarchy' | 'invoice';
    invoiceCode?: string;
    xeroContactID?: string;
  }
  export interface LegalEntityBaseDto {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    legalEntityId?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    externalClientId?: string;
    lei?: string;
    custodianId?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    rowVersion?: string;
    groups?: Array<LegalEntitiesApi.LegalEntitiesGroupDto>;
  }
  export interface AccountingAccountDto {
    id: string;
    name: string;
    accountingType: 'other' | 'legalEntity' | 'sharegain' | 'jpm';
    externalId?: string;
  }
  export interface FeeSplitDto {
    value?: number;
    startDate?: string;
    group?: number;
    accountingAccount?: LegalEntitiesApi.AccountingAccountDto;
  }
  export interface MinorAccountDto {
    accountId?: string;
    accountName?: string;
    custodianId?: string;
    entityAccountId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
    salesPortfolioId?: string;
    rmabic?: string;
    feeSplits?: Array<LegalEntitiesApi.FeeSplitDto>;
    feeSplitsHistory?: Array<LegalEntitiesApi.FeeSplitDto>;
  }
  export enum SftrReportingDto {
    inScope = 'inScope',
    outOfScope = 'outOfScope',
    reportSubClientActivity = 'reportSubClientActivity',
    reportAllActivity = 'reportAllActivity',
  }
  export enum SectorTypeDto {
    none = 'none',
    investmentFirm = 'investmentFirm',
    creditInstitution = 'creditInstitution',
    ucit = 'ucit',
  }
  export interface LenderSwiftConfigurationDto {
    dtcSettlementTransactionIndicator?: 'secl' | 'trad';
    includeLenderSSIs?: boolean;
  }
  export interface MinorConfigurationDto {
    sftrReporting?: 'inScope' | 'outOfScope' | 'reportSubClientActivity' | 'reportAllActivity';
    sectorType?: 'none' | 'investmentFirm' | 'creditInstitution' | 'ucit';
    autoApproveBorrowers?: boolean;
    allowSinglePortfolio?: boolean;
    isSolution15C3?: boolean;
    enabledPortfolioAnalysisApi?: boolean;
    swiftConfiguration?: LegalEntitiesApi.LenderSwiftConfigurationDto;
  }
  export interface ManualSecurityLendingLimitDto {
    bbgid?: string;
    lendingLimit?: number;
  }
  export interface CountryRestrictionDto {
    countryCode?: string;
    securityType?: 'bond' | 'etf' | 'stock';
  }
  export interface TransactionChargeDto {
    chargeForTransaction?: boolean;
    costPerCountry?: any;
  }
  export interface MinorLendingTermsDto {
    supportedSecurityTypes?: Array<'bond' | 'etf' | 'stock'>;
    supportedTradeTypes?: Array<'hold' | 'loan' | 'loanWithoutRecall'>;
    requirePriorApproval?: boolean;
    portfolioValueLimit?: number;
    securityLendingLimit?: number;
    manualSecurityLendingLimits?: Array<LegalEntitiesApi.ManualSecurityLendingLimitDto>;
    countryRestrictions?: Array<LegalEntitiesApi.CountryRestrictionDto>;
    minimumLendingRate?: number;
    recallBlockingPeriodInDays?: number;
    transactionChargeDetails?: LegalEntitiesApi.TransactionChargeDto;
  }
  export interface CashFeeSplitsDto {
    costOfCarryFeeSplit?: LegalEntitiesApi.FeeSplitDto;
    costOfCarryFeeSplitHistory?: Array<LegalEntitiesApi.FeeSplitDto>;
    excessInterestFeeSplit?: LegalEntitiesApi.FeeSplitDto;
    excessInterestFeeSplitHistory?: Array<LegalEntitiesApi.FeeSplitDto>;
    excessReinvestmentFeeSplit?: LegalEntitiesApi.FeeSplitDto;
    excessReinvestmentFeeSplitHistory?: Array<LegalEntitiesApi.FeeSplitDto>;
  }
  export interface LenderRatesResponse {
    costOfCarry?: number;
    interestRateDiff?: number;
    reinvestmentRateDiff?: number;
    interestRate?: number;
    excessInterestRate?: number;
    reinvestmentRate?: number;
    excessReinvestmentRate?: number;
    date?: string;
  }
  export interface LendingCashRatesDto {
    interestRateSourceType?: 'SOFR' | 'OBFR';
    lendingRateHistory?: { [key: string]: LegalEntitiesApi.LenderRatesResponse };
  }
  export interface StandardLenderDto extends LegalEntitiesApi.LegalEntityBaseDto {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    legalEntityId?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    externalClientId?: string;
    lei?: string;
    custodianId?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    rowVersion?: string;
    groups?: Array<LegalEntitiesApi.LegalEntitiesGroupDto>;
    activityState?: 'active' | 'blocked' | 'inactive';
    accounts?: Array<LegalEntitiesApi.MinorAccountDto>;
    bic?: string;
    mancoLEI?: string;
    minorConfiguration?: LegalEntitiesApi.MinorConfigurationDto;
    lendingTerms?: LegalEntitiesApi.MinorLendingTermsDto;
    cashFeeSplits?: LegalEntitiesApi.CashFeeSplitsDto;
    lendingCashRates?: LegalEntitiesApi.LendingCashRatesDto;
    enableSmartPortfolioInsightsPage?: boolean;
    revenueTarget?: number;
    hasOptInAnalysis?: boolean;
  }
  export interface LegalEntityStateDtoAggregatedSettingDto {
    actualValue?: 'active' | 'blocked' | 'inactive';
    aggregatedValue?: 'active' | 'blocked' | 'inactive';
  }
  export interface SubAccountDto {
    accountId?: string;
    accountName?: string;
    custodianId?: string;
    entityAccountId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
    parentAccountId?: string;
  }
  export interface StringArrayAggregatedSettingDto {
    actualValue?: Array<string>;
    aggregatedValue?: Array<string>;
  }
  export interface BooleanAggregatedSettingDto {
    actualValue?: boolean;
    aggregatedValue?: boolean;
  }
  export interface NumberAggregatedSettingDto {
    actualValue?: number;
    aggregatedValue?: number;
  }
  export interface ManualSecurityLendingLimitDtoListAggregatedSettingDto {
    actualValue?: Array<LegalEntitiesApi.ManualSecurityLendingLimitDto>;
    aggregatedValue?: Array<LegalEntitiesApi.ManualSecurityLendingLimitDto>;
  }
  export interface CountryRestrictionDtoListAggregatedSettingDto {
    actualValue?: Array<LegalEntitiesApi.CountryRestrictionDto>;
    aggregatedValue?: Array<LegalEntitiesApi.CountryRestrictionDto>;
  }
  export interface SubLendingTermsDto {
    supportedSecurityTypes?: LegalEntitiesApi.StringArrayAggregatedSettingDto;
    supportedTradeTypes?: LegalEntitiesApi.StringArrayAggregatedSettingDto;
    requirePriorApproval?: LegalEntitiesApi.BooleanAggregatedSettingDto;
    portfolioValueLimit?: LegalEntitiesApi.NumberAggregatedSettingDto;
    securityLendingLimit?: LegalEntitiesApi.NumberAggregatedSettingDto;
    manualSecurityLendingLimits?: LegalEntitiesApi.ManualSecurityLendingLimitDtoListAggregatedSettingDto;
    countryRestrictions?: LegalEntitiesApi.CountryRestrictionDtoListAggregatedSettingDto;
    minimumLendingRate?: LegalEntitiesApi.NumberAggregatedSettingDto;
    recallBlockingPeriodInDays?: LegalEntitiesApi.NumberAggregatedSettingDto;
    transactionChargeDetails?: LegalEntitiesApi.TransactionChargeDto;
  }
  export interface TagDto {
    key: string;
    value: string;
  }
  export interface SubLenderDto extends LegalEntitiesApi.LegalEntityBaseDto {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    legalEntityId?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    externalClientId?: string;
    lei?: string;
    custodianId?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    rowVersion?: string;
    groups?: Array<LegalEntitiesApi.LegalEntitiesGroupDto>;
    activityState?: LegalEntitiesApi.LegalEntityStateDtoAggregatedSettingDto;
    parentLenderId?: string;
    accounts?: Array<LegalEntitiesApi.SubAccountDto>;
    lendingTerms?: LegalEntitiesApi.SubLendingTermsDto;
    leAutomationEnabled?: boolean;
    feeSplit?: LegalEntitiesApi.FeeSplitDto;
    allowSinglePortfolio?: boolean;
    enableSmartPortfolioInsightsPage?: boolean;
    canEditLendingTerms?: boolean;
    tags?: Array<LegalEntitiesApi.TagDto>;
    revenueTarget?: number;
  }
  export interface SuperLenderDto extends LegalEntitiesApi.LegalEntityBaseDto {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    legalEntityId?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    externalClientId?: string;
    lei?: string;
    custodianId?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    rowVersion?: string;
    groups?: Array<LegalEntitiesApi.LegalEntitiesGroupDto>;
    activityState?: 'active' | 'blocked' | 'inactive';
    accounts?: Array<LegalEntitiesApi.MinorAccountDto>;
    bic?: string;
    mancoLEI?: string;
    allocationAlgorithmType?: string;
    reportNonMinorsToContemi?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    disablePvlSettingChange?: boolean;
    minorConfiguration?: LegalEntitiesApi.MinorConfigurationDto;
    lendingTerms?: LegalEntitiesApi.MinorLendingTermsDto;
    cashFeeSplits?: LegalEntitiesApi.CashFeeSplitsDto;
    lendingCashRates?: LegalEntitiesApi.LendingCashRatesDto;
    leAutomationEnabled?: boolean;
    autoSubstitution?: boolean;
    enableSmartPortfolioInsightsPage?: boolean;
    optInYearlyGoal?: number;
    hasOptInAnalysis?: boolean;
    revenueTarget?: number;
    numOptedInClientsTarget?: number;
    excessAllocationSubLenderId?: string;
    excessAllocationMode?: 'full' | 'loanCreationOnly';
    returnMethod?: 'proRata' | 'wholeSubLoans';
    minimumPieceMode?: 'default' | 'none' | 'amount';
    minimumPieceAmount?: number;
  }
  export interface AccountDto {
    accountId?: string;
    accountName?: string;
    custodianId?: string;
    entityAccountId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
  }
  export enum SharegainEntityTypeDto {
    sharegainLtd = 'sharegainLtd',
    sharegainSecuritiesInc = 'sharegainSecuritiesInc',
  }
  export interface BorrowerDto extends LegalEntitiesApi.LegalEntityBaseDto {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    legalEntityId?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    externalClientId?: string;
    lei?: string;
    custodianId?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    rowVersion?: string;
    groups?: Array<LegalEntitiesApi.LegalEntitiesGroupDto>;
    masterAgreementVersion?: number;
    collateralTermsOverride?: number;
    accounts?: Array<LegalEntitiesApi.AccountDto>;
    activityState?: 'active' | 'blocked' | 'inactive';
    sharegainEntityType?: 'sharegainLtd' | 'sharegainSecuritiesInc';
    isPirumCashMarksParticipant?: boolean;
  }
  export interface ProblemDetails {
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;
  }
  export interface ValidationProblemDetails {
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;
    errors?: any;
  }
  export interface SearchLegalEntitiesRequest {
    ids?: Array<string>;
    companies?: Array<string>;
    codes?: Array<string>;
    leIs?: Array<string>;
    types?: Array<'standardLender' | 'subLender' | 'superLender' | 'borrower'>;
    name?: string;
    activityState?: 'active' | 'blocked' | 'inactive';
    inheritance?: boolean;
    skipApprovedEntities?: boolean;
    skipSGFeeSplits?: boolean;
    allowPartialCodeSearchForSingleCode?: boolean;
    custodiansIds?: Array<string>;
    externalClientsIds?: Array<string>;
    parentIds?: Array<string>;
    isMinorCode?: boolean;
  }
  export interface SearchLegalEntitiesOrderSortingDto {
    sortDirection?: string;
    orderBy?: string;
  }
  export interface PagingDto {
    totalPages?: number;
    pageNumber?: number;
    totalRows?: number;
  }
  export interface LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto {
    rows?: Array<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >;
    sorting?: LegalEntitiesApi.SearchLegalEntitiesOrderSortingDto;
    paging?: LegalEntitiesApi.PagingDto;
  }
  export interface LendingTermsRequest {
    supportedSecurityTypes?: Array<'bond' | 'etf' | 'stock'>;
    supportedTradeTypes?: Array<'hold' | 'loan' | 'loanWithoutRecall'>;
    requirePriorApproval?: boolean;
    recallBlockingPeriodInDays?: number;
    transactionChargeDetails?: LegalEntitiesApi.TransactionChargeDto;
    manualSecurityLendingLimits?: Array<LegalEntitiesApi.ManualSecurityLendingLimitDto>;
    countryRestrictions?: Array<LegalEntitiesApi.CountryRestrictionDto>;
    portfolioValueLimit?: number;
    securityLendingLimit?: number;
    minimumLendingRate?: number;
  }
  export interface CreateLenderAccountRequest {
    accountId?: string;
    accountName?: string;
    entityAccountId?: string;
    custodianId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
    salesPortfolioId?: string;
    rmabic?: string;
    feeSplits?: Array<LegalEntitiesApi.FeeSplitDto>;
  }
  export interface CreateSuperLenderLegalEntityRequest
    extends LegalEntitiesApi.CreateLenderLegalEntityBase {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    autoApproveBorrowers?: boolean;
    bic?: string;
    sftrReporting: 'inScope' | 'outOfScope' | 'reportSubClientActivity' | 'reportAllActivity';
    sectorType?: 'none' | 'investmentFirm' | 'creditInstitution' | 'ucit';
    lei?: string;
    mancoLEI?: string;
    enabledPortfolioAnalysisApi?: boolean;
    allocationAlgorithmType: string;
    autoSubstitution?: boolean;
    swiftConfiguration?: LegalEntitiesApi.LenderSwiftConfigurationDto;
    leAutomationEnabled?: boolean;
    id?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    feeSplit?: number;
    accounts: Array<LegalEntitiesApi.CreateLenderAccountRequest>;
    reportNonMinorsToContemi?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    disablePvlSettingChange?: boolean;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    costOfCarryFeeSplit?: number;
    excessInterestFeeSplit?: number;
    excessReinvestmentFeeSplit?: number;
    optInYearlyGoal?: number;
    hasOptInAnalysis?: boolean;
    excessAllocationSubLenderId?: string;
    excessAllocationMode?: 'full' | 'loanCreationOnly';
    returnMethod?: 'proRata' | 'wholeSubLoans';
    minimumPieceMode?: 'default' | 'none' | 'amount';
    minimumPieceAmount?: number;
  }
  export interface CreateStandardLenderLegalEntityRequest
    extends LegalEntitiesApi.CreateLenderLegalEntityBase {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    autoApproveBorrowers?: boolean;
    bic?: string;
    sftrReporting: 'inScope' | 'outOfScope' | 'reportSubClientActivity' | 'reportAllActivity';
    sectorType?: 'none' | 'investmentFirm' | 'creditInstitution' | 'ucit';
    lei?: string;
    mancoLEI?: string;
    enabledPortfolioAnalysisApi?: boolean;
    swiftConfiguration?: LegalEntitiesApi.LenderSwiftConfigurationDto;
    id?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    feeSplit?: number;
    accounts: Array<LegalEntitiesApi.CreateLenderAccountRequest>;
    reportNonMinorsToContemi?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    disablePvlSettingChange?: boolean;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    costOfCarryFeeSplit?: number;
    excessInterestFeeSplit?: number;
    excessReinvestmentFeeSplit?: number;
    hasOptInAnalysis?: boolean;
  }
  export interface CreateSubAccountRequest {
    accountId?: string;
    accountName?: string;
    entityAccountId?: string;
    custodianId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
    parentAccountId?: string;
  }
  export interface CreateSubLenderLegalEntityRequest
    extends LegalEntitiesApi.CreateLenderLegalEntityBase {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    parentLenderId: string;
    canEditLendingTerms?: boolean;
    id?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    active?: boolean;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    feeSplit?: number;
    accounts: Array<LegalEntitiesApi.CreateSubAccountRequest>;
    reportNonMinorsToContemi?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    disablePvlSettingChange?: boolean;
    externalClientId: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    lei?: string;
  }
  export interface CreateBorrowerAccountRequest {
    accountId?: string;
    accountName?: string;
    entityAccountId?: string;
    custodianId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
  }
  export interface CreateBorrowerLegalEntityRequest extends LegalEntitiesApi.CreateLegalEntityBase {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    collateralTermsOverride?: number;
    lei: string;
    masterAgreementVersion: number;
    accounts: Array<LegalEntitiesApi.CreateBorrowerAccountRequest>;
    sharegainEntityType: LegalEntitiesApi.SharegainEntityTypeDto;
    id?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    isPirumCashMarksParticipant?: boolean;
  }
  export interface CreateLenderLegalEntityBase extends LegalEntitiesApi.CreateLegalEntityBase {
    allowSinglePortfolio?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    feeSplit?: number;
    accounts?: Array<LegalEntitiesApi.CreateLenderAccountRequest>;
    reportNonMinorsToContemi?: boolean;
    disablePvlSettingChange?: boolean;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
  }
  export interface CreateLegalEntityBase {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    id?: string;
    name: string;
    code: string;
    company: string;
    currency: string;
    active?: boolean;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export enum LegalEntityStateDto {
    active = 'active',
    blocked = 'blocked',
    inactive = 'inactive',
  }
  export interface UpdateBorrowerAccountRequest {
    accountId?: string;
    accountName?: string;
    entityAccountId?: string;
    custodianId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
  }
  export interface UpdateBorrowerLegalEntityRequest extends LegalEntitiesApi.UpdateLegalEntityBase {
    activityState: LegalEntitiesApi.LegalEntityStateDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    name?: string;
    code?: string;
    currency?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    collateralTermsOverride?: number;
    lei?: string;
    masterAgreementVersion?: number;
    accounts?: Array<LegalEntitiesApi.UpdateBorrowerAccountRequest>;
    sharegainEntityType?: 'sharegainLtd' | 'sharegainSecuritiesInc';
    isPirumCashMarksParticipant?: boolean;
  }
  export interface UpdateLenderAccountRequest {
    accountId?: string;
    accountName?: string;
    entityAccountId?: string;
    custodianId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
    salesPortfolioId?: string;
    rmabic?: string;
    feeSplits?: Array<LegalEntitiesApi.FeeSplitDto>;
  }
  export interface UpdateLenderRatesByDateRequest {
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    date?: string;
    costOfCarry?: number;
    interestRateDiff?: number;
    reinvestmentRateDiff?: number;
  }
  export interface UpdateStandardLenderLegalEntityRequest
    extends LegalEntitiesApi.UpdateLenderLegalEntityBase {
    activityState: LegalEntitiesApi.LegalEntityStateDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    name?: string;
    code?: string;
    currency?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    feeSplit?: number;
    accounts?: Array<LegalEntitiesApi.UpdateLenderAccountRequest>;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    cashSplitsEffectiveDate?: string;
    costOfCarryFeeSplit?: number;
    excessInterestFeeSplit?: number;
    excessReinvestmentFeeSplit?: number;
    autoApproveBorrowers?: boolean;
    bic?: string;
    sftrReporting?: 'inScope' | 'outOfScope' | 'reportSubClientActivity' | 'reportAllActivity';
    sectorType?: 'none' | 'investmentFirm' | 'creditInstitution' | 'ucit';
    lei?: string;
    mancoLEI?: string;
    enabledPortfolioAnalysisApi?: boolean;
    swiftConfiguration?: LegalEntitiesApi.LenderSwiftConfigurationDto;
    interestRateSourceType?: 'SOFR' | 'OBFR';
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    hasOptInAnalysis?: boolean;
    lenderRates?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
  }
  export interface UpdateSubAccountRequest {
    accountId?: string;
    accountName?: string;
    entityAccountId?: string;
    custodianId?: string;
    custodianAccountId?: string;
    isSwift?: boolean;
    parentAccountId?: string;
  }
  export interface UpdateSubLenderLegalEntityRequest
    extends LegalEntitiesApi.UpdateLenderLegalEntityBase {
    activityState: LegalEntitiesApi.LegalEntityStateDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    name?: string;
    code?: string;
    currency?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    feeSplit?: number;
    accounts?: Array<LegalEntitiesApi.UpdateSubAccountRequest>;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    cashSplitsEffectiveDate?: string;
    costOfCarryFeeSplit?: number;
    excessInterestFeeSplit?: number;
    excessReinvestmentFeeSplit?: number;
    canEditLendingTerms?: boolean;
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    lei?: string;
  }
  export interface UpdateSuperLenderLegalEntityRequest
    extends LegalEntitiesApi.UpdateLenderLegalEntityBase {
    activityState: LegalEntitiesApi.LegalEntityStateDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    name?: string;
    code?: string;
    currency?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    feeSplit?: number;
    accounts?: Array<LegalEntitiesApi.UpdateLenderAccountRequest>;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    cashSplitsEffectiveDate?: string;
    costOfCarryFeeSplit?: number;
    excessInterestFeeSplit?: number;
    excessReinvestmentFeeSplit?: number;
    autoApproveBorrowers?: boolean;
    bic?: string;
    sftrReporting?: 'inScope' | 'outOfScope' | 'reportSubClientActivity' | 'reportAllActivity';
    sectorType?: 'none' | 'investmentFirm' | 'creditInstitution' | 'ucit';
    lei?: string;
    mancoLEI?: string;
    allocationAlgorithmType?: string;
    autoSubstitution?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    reportNonMinorsToContemi?: boolean;
    disablePvlSettingChange?: boolean;
    enabledPortfolioAnalysisApi?: boolean;
    swiftConfiguration?: LegalEntitiesApi.LenderSwiftConfigurationDto;
    interestRateSourceType?: 'SOFR' | 'OBFR';
    lendingTerms?: LegalEntitiesApi.LendingTermsRequest;
    lenderRates?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
    optInYearlyGoal?: number;
    hasOptInAnalysis?: boolean;
    excessAllocationSubLenderId?: string;
    excessAllocationMode?: 'full' | 'loanCreationOnly';
    returnMethod?: 'proRata' | 'wholeSubLoans';
    minimumPieceMode?: 'default' | 'none' | 'amount';
    minimumPieceAmount?: number;
  }
  export interface UpdateLenderLegalEntityBase extends LegalEntitiesApi.UpdateLegalEntityBase {
    activityState: LegalEntitiesApi.LegalEntityStateDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    name?: string;
    code?: string;
    currency?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
    allowSinglePortfolio?: boolean;
    feeSplit?: number;
    accounts?: Array<LegalEntitiesApi.UpdateLenderAccountRequest>;
    externalClientId?: string;
    enableSmartPortfolioInsightsPage?: boolean;
    isSolution15C3?: boolean;
    cashSplitsEffectiveDate?: string;
    costOfCarryFeeSplit?: number;
    excessInterestFeeSplit?: number;
    excessReinvestmentFeeSplit?: number;
  }
  export interface UpdateLegalEntityBase {
    activityState: LegalEntitiesApi.LegalEntityStateDto;
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    name?: string;
    code?: string;
    currency?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface ApprovedEntityDetails {
    legalEntityId: string;
    legalEntityName?: string;
    mutuallyApproved?: boolean;
    collateralTypes?: Array<'Cash' | 'NonCash'>;
  }
  export interface UpsertApprovedEntitiesResponse {
    rowVersion?: number;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    approvedEntities?: Array<LegalEntitiesApi.ApprovedEntityDetails>;
  }
  export interface UpsertApprovedEntitiesRequest {
    approvedEntities: Array<LegalEntitiesApi.ApprovedEntityDetails>;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface UpdateActivityStatusRequest {
    type: LegalEntitiesApi.LegalEntityTypeEnum;
    activityState?: 'active' | 'blocked' | 'inactive';
    updateOnlyAggregated?: boolean;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export enum AccountTypeEnum {
    regularAccount = 'regularAccount',
    minorAccount = 'minorAccount',
    subAccount = 'subAccount',
  }
  export enum LegalEntityStateEnum {
    active = 'active',
    blocked = 'blocked',
    inactive = 'inactive',
  }
  export interface AccountResponse {
    type: LegalEntitiesApi.AccountTypeEnum;
    legalEntityId?: string;
    company?: string;
    legalEntityType: LegalEntitiesApi.LegalEntityTypeEnum;
    rowVersion?: number;
    account?:
      | LegalEntitiesApi.AccountDto
      | LegalEntitiesApi.MinorAccountDto
      | LegalEntitiesApi.SubAccountDto;
    legalEntityActivityState?: 'active' | 'blocked' | 'inactive';
  }
  export interface MinorAccountResponse {
    type: LegalEntitiesApi.AccountTypeEnum;
    legalEntityId?: string;
    company?: string;
    legalEntityType: LegalEntitiesApi.LegalEntityTypeEnum;
    rowVersion?: number;
    account?: LegalEntitiesApi.MinorAccountDto;
    legalEntityActivityState: LegalEntitiesApi.LegalEntityStateEnum;
  }
  export interface SubAccountResponse {
    type: LegalEntitiesApi.AccountTypeEnum;
    legalEntityId?: string;
    company?: string;
    legalEntityType: LegalEntitiesApi.LegalEntityTypeEnum;
    rowVersion?: number;
    account?: LegalEntitiesApi.SubAccountDto;
    parentLenderId?: string;
    legalEntityActivityState?: LegalEntitiesApi.LegalEntityStateDtoAggregatedSettingDto;
  }
  export interface SearchLegalEntitiesAccountRequest {
    allowPartialMatching?: boolean;
    accountNames?: Array<string>;
    accountIds?: Array<string>;
    entityAccountIds?: Array<string>;
    salesPortfolioIds?: Array<string>;
    custodianIds?: Array<string>;
    legalEntityIds?: Array<string>;
    parentAccountIds?: Array<string>;
    companies?: Array<string>;
    legalEntityTypes?: Array<'standardLender' | 'subLender' | 'superLender' | 'borrower'>;
  }
  export interface SearchLegalEntitiesAccountsOrderDtoSortingDto {
    sortDirection?: 'asc' | 'desc';
    orderBy?: 'accountId' | 'legalEntityId' | 'salesPortfolioId' | 'custodianId' | 'defaultSort';
  }
  export interface BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto {
    rows?: Array<
      | LegalEntitiesApi.AccountResponse
      | LegalEntitiesApi.MinorAccountResponse
      | LegalEntitiesApi.SubAccountResponse
    >;
    sorting?: LegalEntitiesApi.SearchLegalEntitiesAccountsOrderDtoSortingDto;
    paging?: LegalEntitiesApi.PagingDto;
  }
  export interface ErrorResponse {
    errorMessage?: string;
    innerException?: LegalEntitiesApi.ErrorResponse;
    stackTrace?: string;
  }
  export interface MatchedCodeDto {
    matchedCodeId?: string;
    sourceAccountId?: string;
    sourceLegalEntityId?: string;
    targetLegalEntityId?: string;
    targetLegalEntityName?: string;
    targetAccountId?: string;
    targetAccountName?: string;
    bilateralAccountNumber?: string;
    counterPartyAccountCode?: string;
    rowVersion?: number;
    entityAccountId?: string;
  }
  export interface MatchCodeRelationDto {
    sourceAccountId?: string;
    targetAccountId?: string;
    sourceLegalEntityId?: string;
    targetLegalEntityId?: string;
    counterPartyAccountCode?: string;
    bilateralAccountNumber?: string;
    rowVersion?: number;
  }
  export interface MatchedCodesUpdateRequest {
    relations?: Array<LegalEntitiesApi.MatchCodeRelationDto>;
  }
  export interface SearchLenderRatesByDateRequest {
    dateFrom?: string;
    dateTo?: string;
  }
  export interface LenderRatesDto {
    date?: string;
    costOfCarry?: number;
    interestRate?: number;
    interestRateDiff?: number;
    excessInterestRate?: number;
    reinvestmentRate?: number;
    reinvestmentRateDiff?: number;
    excessReinvestmentRate?: number;
  }
  export interface OptimisticLockAuditRequest {
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface SearchLendersCashFeeSplitsRequest {
    legalEntitiesIds?: Array<string>;
    cashFeeSplitTypes?: Array<
      'all' | 'costOfCarryFeeSplits' | 'excessInterestFeeSplits' | 'excessReinvestmentFeeSplits'
    >;
  }
  export interface CashFeeSplitsResponse {
    legalEntityId?: string;
    costOfCarryFeeSplits?: Array<LegalEntitiesApi.FeeSplitDto>;
    excessInterestFeeSplits?: Array<LegalEntitiesApi.FeeSplitDto>;
    excessReinvestmentFeeSplits?: Array<LegalEntitiesApi.FeeSplitDto>;
  }
  export interface CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto {
    rows?: Array<LegalEntitiesApi.CashFeeSplitsResponse>;
    sorting?: LegalEntitiesApi.SearchLegalEntitiesOrderSortingDto;
    paging?: LegalEntitiesApi.PagingDto;
  }
  export interface SearchLenderCashFeeSplitsRequest {
    cashFeeSplitTypes?: Array<
      'all' | 'costOfCarryFeeSplits' | 'excessInterestFeeSplits' | 'excessReinvestmentFeeSplits'
    >;
  }
  export interface ApprovedEntities {
    legalEntityId: string;
    approvedEntitiesDetails: Array<LegalEntitiesApi.ApprovedEntityDetails>;
    rowVersion: string;
  }
  export interface DateRangeRequestDto {
    dateFrom: string;
    dateTo: string;
  }
  export interface AccountFeeSplitResponse {
    legalEntityId: string;
    account: LegalEntitiesApi.MinorAccountDto;
    feeSplits: Array<LegalEntitiesApi.FeeSplitDto>;
  }
  export interface LegalEntityFeeSplitsDto {
    rowVersion?: string;
    createAudit?: LegalEntitiesApi.AuditDto;
    updateAudit?: LegalEntitiesApi.AuditDto;
    legalEntityId?: string;
    feeSplits?: any;
  }
  export interface UploadRecommendationsResponseDto {
    success?: boolean;
    recommendationsCreated?: number;
    expiredRecommendations?: number;
    errors?: Array<string>;
  }
  export interface SetMilestoneTargetsRequest {
    revenueTarget?: number;
    numOptedInClientsTarget?: number;
  }
  export interface SearchLegalEntitiesGroupsRequest {
    ids?: Array<string>;
    companies?: Array<string>;
    legalEntityIds?: Array<string>;
    groupTypes?: Array<'billing' | 'caNotification' | 'general' | 'hierarchy' | 'invoice'>;
    name?: string;
  }
  export interface SearchLegalEntitiesGroupsOrderSortingDto {
    sortDirection?: 'asc' | 'desc';
    orderBy?: 'default';
  }
  export interface LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto {
    rows?: Array<LegalEntitiesApi.LegalEntitiesGroupDto>;
    sorting?: LegalEntitiesApi.SearchLegalEntitiesGroupsOrderSortingDto;
    paging?: LegalEntitiesApi.PagingDto;
  }
  export interface CreateLegalEntitiesGroupRequest {
    id?: string;
    name: string;
    company: string;
    legalEntitiesIds: Array<string>;
    description?: string;
    groupType: 'billing' | 'caNotification' | 'general' | 'hierarchy' | 'invoice';
    invoiceCode?: string;
    xeroContactId?: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface UpdateLegalEntitiesGroupRequest {
    name: string;
    legalEntitiesIds?: Array<string>;
    description?: string;
    invoiceCode?: string;
    xeroContactId?: string;
    rowVersion: string;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface ReservationDto {
    id?: string;
    lenderLegalEntityId?: string;
    borrowerLegalEntityId?: string;
    securityType?: 'stock' | 'etf' | 'bond';
    markets?: Array<string>;
    accountIds?: Array<string>;
    createAudit?: LegalEntitiesApi.AuditDto;
    liftAudit?: LegalEntitiesApi.AuditDto;
    isLifted?: boolean;
  }
  export interface CreateReservationRequest {
    borrowerLegalEntityId: string;
    securityType: 'stock' | 'etf' | 'bond';
    markets?: Array<string>;
    accountIds?: Array<string>;
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface LiftReservationRequest {
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface AnalyzerUploadDto {
    id?: string;
    status?: 'pending' | 'completed' | 'failed' | 'processing' | 'validationError';
    createdAt?: string;
    fileName?: string;
    asOfDate?: string;
    processingStartedAt?: string;
    submittedBy?: string;
    isRemovable?: boolean;
  }
  export interface DeleteAnalyzerUploadRequest {
    requestAudit?: LegalEntitiesApi.AuditDto;
  }
  export interface SearchLegalEntitiesByPartialCodeRequest {
    companies?: Array<string>;
    code: string;
  }
}
